import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const fetchPurchaseOrderService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PURCHASE_ORDER}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const editPurchaseOrderService = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PURCHASE_ORDER}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const downloadPo = async (data, id) => {
  try {
    // return await apiClient.get(
    return await apiClient.post(`${apiEndpoint}${API.PURCHASE_ORDER.DOWNLOAD_PO_DOCS}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDevorderColourwaysService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_DEVORDER}/${data}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDevorderSupplierService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_SUPPLIER}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPoTemplateService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_POTEMPLATE}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProfileService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PROFILE}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fethcPoDetailsService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PODETAILS}/${data.devOrderId}`, {
      params: { poOrderId: data.poOrderId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createPoPermissionService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_CREATE_PO_PERMISSION}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addPurchaseOrder = async (data, id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PURCHASE_ORDER.ADD_PO}/${id}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchTradeRefService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_TRADE_REF}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getEditPurchaseOrder = async (data, id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.ADD_PO}/${id}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const putEditPurchaseOrder = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.ADD_PO}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postStatus = async (id, devId, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.ADD_PO}/${devId}/${id}/status`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePurchaseOrder = async (id, devId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PURCHASE_ORDER.ADD_PO}/${devId}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchMaterialPlacementComponentService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_MATERIAL_PLACEMENT}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchLegLengthsService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_LEG_LENGTHS}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchSizesService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_SIZES}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPODocumentsService = async (data, id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_DOCUMENTS}/${id}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPreviewData = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.HISTORY_PREVIEW}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPublicPoData = async (poId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.PUBLIC_PO}`, { params: { poId } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPublicDevDetails = async (devDetails) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.PUBLIC_PO}`, { params: { ...devDetails } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPublicPurchasePoData = async (poId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.PUBLIC_PURCHASE_PO}`, { params: { poId } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchShipmentDates = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.SHIPMENT_DATES}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePODocumentsService = async (data, id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_DOCUMENTS}/${id}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editPODocumentsService = async (data, payload, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_DOCUMENTS}/${id}`, { ...payload }, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postShipmentDates = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PURCHASE_ORDER.SAVE_SHIPMENT_DATES}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const markComplete = async (data, qData, id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PURCHASE_ORDER.MARK_COMPLETE}/${id}/po`, { ...data }, { params: qData });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postPODocumentsService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PURCHASE_ORDER.POST_DOCUMENTS}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updatePOTemplateService = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PODETAILS}/${data.poCreatedId}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updatePurchaseOrderService = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PODETAILS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPurchaseOrderHistoryService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PO_HISTORY}/${data.poId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPurchaseOrderLogService = async (devId, data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PODETAILS}/${devId}/po-log`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const revisePoService = async (obj, reqObj) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PODETAILS}/${obj.poId}/status`, { ...reqObj });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const rejectApproveService = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PURCHASE_ORDER.APPROVE_REJECT_STATUS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchOldPoPreviewService = async (poOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_PURCHASE_ORDER.FETCH_OLD_PO_PREVIEW}/${poOrderId}`, {
      params: {},
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
